var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.component)?_c(_vm.component,_vm._b({tag:"component"},'component',{..._vm.params},false)):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }